import { render, staticRenderFns } from "./LeagueMydetail.vue?vue&type=template&id=81ef9092&"
import script from "./LeagueMydetail.vue?vue&type=script&lang=js&"
export * from "./LeagueMydetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports